var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "windows-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00675551471,8.47058824 L0,2.5925293 L7.41176471,1.53140915 L7.41176471,8.47058824 L0.00675551471,8.47058824 Z M8.47058824,1.40827311 L18,0 L18,8.47058824 L8.47058824,8.47058824 L8.47058824,1.40827311 Z M18,9.52941176 L17.9976921,18 L8.47058824,16.6383529 L8.47058824,9.52941176 L18,9.52941176 Z M7.41176471,16.4210785 L0.000386323178,15.3613281 L0,9.52941176 L7.41176471,9.52941176 L7.41176471,16.4210785 Z",
    id: "Shape",
    fill: "#03A9E9",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.cb82402da65e80fd7f351d1b024e9378.svg";
export { ForwardRef as ReactComponent };